<template>
    <div class="main" id="case">
      <div class="case-list">
        <template v-for="(item,index) in navList">
          <div class="item" :key="index">
            <div class="pic">
              <img :src="item.img" :alt="item.title">
            </div>
            <div class="info">
              <div class="title">{{ item.title }}</div>
              <div class="desc">{{ item.desc }}</div>
              <!-- <div class="lines">
                <div class="line" v-for="(line,lineIndex) in item.lines" :key="lineIndex">
                  <i class="el-icon-caret-right"></i>
                  <a>{{ line.text }}</a>
                </div>
              </div> -->
            </div>
          </div>
        </template>
      </div>
    </div>
</template>

<script>
import customData from './data';
export default {
  props:{
    navIndex:Number,
  },
    data() {
        return {
            navList: customData.caseList
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/case/navItem.vue